<template>
  <base-widget
    v-slot="{current}"
    title="History"
    :items="components"
    scrollable
  >
    <template>
      <orders
        v-if="checkTab(current)"
        :orders="orders"
        :loading="loading"
      />
      <contacts
        v-else
        :items="contacts.items"
        :count="contacts.count"
        :loading="loading"
        @page-change="$emit('contact-page-change', $event)"
        @events-clicked="$emit('events-clicked', $event)"
      />
    </template>
  </base-widget>
</template>

<script>

import Orders from './ClientHistory/Orders';
import Contacts from './ClientHistory/Contacts';

export default {
  name: 'ClientHistory',
  components: {
    Orders,
    Contacts,
  },
  props: {
    orders: {
      type: Array,
      default: () => [],
    },
    contacts: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    reverse: {
      type: Boolean,
      default: false,
    },
    isIntegrated: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      current: '',
    };
  },
  computed: {
    components() {
      const items = this.isIntegrated ? ['Order History', 'Contact History'] : ['Contact History'];
      if (this.reverse) {
        return items.reverse();
      }
      return items;
    },
    heightStyles() {
      if (this.components[this.current] === 'Order History') {
        return {
          'min-height': '180px',
          height: `calc(${this.height} - ${this.offsetTop}px - ${this.marginBottom})`,
          'max-height': `calc(${this.height} - ${this.offsetTop}px - ${this.marginBottom})`,
        };
      }
      return {
        'max-height': '773px',
        height: '773px',
      };
    },
  },
  methods: {
    checkTab(current) {
      this.current = current;
      return this.components[current] === 'Order History';
    },
  },
};
</script>

<style lang="css" scoped>
</style>
